import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/filter-chiclet-remove.svg'


const _withScopeId = n => (_pushScopeId("data-v-3fe34df7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-chiclet" }
const _hoisted_2 = { class: "c-chiclet-label" }
const _hoisted_3 = { class: "c-chiclet-label-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.filterType), 1)
    ]),
    _createElementVNode("img", {
      class: "remove-icon",
      src: _imports_0,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerRemoval && _ctx.triggerRemoval(...args)))
    })
  ]))
}